var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-group',{attrs:{"multiple":"","show-arrows":""}},_vm._l((_vm.jobSuggestions),function(job){return _c('v-slide-item',{key:job.id,staticClass:"mx-3"},[_c('JobCardItem',{attrs:{"job":job}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }